import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client';
import { UpdatePersonIdentity } from 'Apollo';
import useTranslate from 'Hooks/useTranslate';
import useNotification from 'Hooks/useNotification';
import ButtonLoading from 'Theme/components/ButtonLoading';
import { enqueueSnackbar } from 'notistack';

interface Props {
  identity: string;
  personIdentifier: string;
  organizationCode: string;
  directoryCode: string;
  onClose: () => void;
}

function EditIdentityIdentifierDialog(props: Readonly<Props>) {
  const { identity, personIdentifier, organizationCode, directoryCode, onClose } = props;
  const ts = useTranslate();
  const { onError } = useNotification();
  const [value, setValue] = useState(identity);

  const handleCompleted = () => {
    enqueueSnackbar(<FormattedMessage id="page.userProfile.editIdentity.success" />, {
      variant: 'success'
    });

    onClose();
  };

  const [updatePersonIdentity, { loading }] = useMutation<
    {},
    UpdatePersonIdentityVariables
  >(UpdatePersonIdentity, {
    variables: {
      personIdentifier,
      organizationCode,
      data: {
        directoryCode,
        newIdentityImmutableId: value
      }
    },
    refetchQueries: ['GetDirectoriesExtendedInfo'],
    onCompleted: handleCompleted,
    onError
  });

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
      <form
        onSubmit={e => {
          e.preventDefault();
          updatePersonIdentity();
        }}
      >
        <DialogTitle>
          {ts('page.userProfile.editIdentity.editIdentityIdentifier')}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="error" paragraph fontWeight="bold">
            {ts('page.userProfile.editIdentity.warning')}
          </Typography>
          <TextField
            fullWidth
            value={value}
            onChange={e => setValue(e.target.value)}
            variant="outlined"
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            <FormattedMessage id="common.action.cancel" />
          </Button>
          <ButtonLoading type="submit" color="primary" variant="contained" loading={loading}>
            <FormattedMessage id="common.action.validate" />
          </ButtonLoading>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default EditIdentityIdentifierDialog;
